const usersRole = {
    MEMBER: "Member", 
    SUPER_ADMIN: "SuperAdmin",
    ADMIN: "Admin"       
}

export default usersRole;
